<script setup lang="ts">
import PropertyInvestmentPanel from '@/components/portfolio/PropertyInvestmentPanel.vue'
import PropertyLoansCard from '@/components/portfolio/PropertyLoansCard.vue'
import type { ExtendedEnum } from '@/types'
import type { FieldStateMap } from '@/utils/field-state'
import { ref } from 'vue'
import EstateObjectData = App.Data.EstateObject.EstateObjectData
import LoanData = App.Data.EstateObject.LoanData
import ModernizationData = App.Data.EstateObject.ModernizationData
import CollateralType = App.Enums.EstateObject.Loans.CollateralType
import FinancingType = App.Enums.EstateObject.Loans.FinancingType
import MezzanineType = App.Enums.EstateObject.Loans.MezzanineType

defineProps<{
  estateObject: EstateObjectData
  fieldStates: FieldStateMap
  loans: LoanData[]
  modernizations: ModernizationData[]
  financingTypes: ExtendedEnum<FinancingType>[]
  mezzanineTypes: ExtendedEnum<MezzanineType>[]
  collateralTypes: ExtendedEnum<CollateralType>[]
}>()

const emit = defineEmits<{
  openModernizations: []
}>()

const financing = ref({ total: 0, count: 0 })

const loansCard = ref<InstanceType<typeof PropertyLoansCard> | null>(null)
</script>

<template>
  <div class="flex flex-col gap-4">
    <PropertyInvestmentPanel
      :estate-object="estateObject"
      :field-states="fieldStates"
      :modernizations="modernizations"
      :loans-total="financing.total"
      :loans-count="financing.count"
      @open-modernizations="emit('openModernizations')"
      @add-financing="loansCard?.addLoan()" />

    <PropertyLoansCard
      ref="loansCard"
      :estate-object-id="estateObject.id ?? ''"
      :loans="loans"
      :financing-types="financingTypes"
      :mezzanine-types="mezzanineTypes"
      :collateral-types="collateralTypes"
      @financing-change="financing = $event" />
  </div>
</template>
